module.exports = __webpack_public_path__ + "img/StatsIcon.6e2bc9ce.png";